<h1 id="title" class="title color-brand">Recuperar Senha</h1>
<p class="paragraph">
    Esqueceu sua senha? <br />
    Siga as etapas abaixo para fazer a recuperação.
</p>
<hr class="divider" />
<nb-alert *ngIf="alert.show" [status]="alert.type" role="alert">
    {{ alert.message }}
</nb-alert>
<nb-stepper #stepper disableStepNavigation linear>
    <nb-step>
        <p class="paragraph">Selecione um método para recuperação</p>

        <nb-radio-group
            class="row justify-content-center"
            [(ngModel)]="selectedMethod"
            (ngModelChange)="onMethodChange()"
        >
            <nb-radio class="col-auto" *ngFor="let method of (recoveryMethods$ | async)?.registers" [value]="method">
                {{ method.descricao }}
            </nb-radio>
        </nb-radio-group>
        <form [formGroup]="form" (ngSubmit)="onRequestFind()" *ngIf="selectedMethod">
            <div class="form-control-group">
                <label class="label">{{ selectedMethod.descricao }}</label>
                <input nbInput type="text" formControlName="recovery_method" [mask]="mask" fullWidth />
            </div>
            <div class="d-flex justify-content-center">
                <button nbButton type="submit">Enviar <nb-icon icon="arrow-ios-forward-outline"></nb-icon></button>
            </div>
        </form>
    </nb-step>
    <nb-step>
        <app-user-found
            *ngFor="let user of usersFound"
            [user]="user"
            [selection]="true"
            (select)="onUserSelect($event)"
        ></app-user-found>
        <nb-card *ngIf="!usersFound?.length">
            <nb-card-body>
                <p class="paragraph">Nenhum usuário encontrado com os dados informados.</p>
                <p class="paragraph">Verifique se digitou os dados corretamente.</p>
            </nb-card-body>
        </nb-card>
        <div class="d-flex justify-content-center mt-2">
            <button nbButton (click)="stepper.previous()" *ngIf="!usersFound?.length">
                Tentar novamente <nb-icon icon="repeat-outline"></nb-icon>
            </button>
            <button nbButton (click)="stepper.next()" [disabled]="!player" *ngIf="usersFound?.length">
                Avançar <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
            </button>
        </div>
    </nb-step>
    <nb-step>
        <app-token-request type="0" [player]="player" (sent)="onTokenSent($event)" *ngIf="player"></app-token-request>
    </nb-step>
    <nb-step>
        <app-token-validate
            type="2"
            [player]="player"
            [codeToken]="codeToken"
            [typeSending]="typeSending"
            (validate)="onValidationSuccess()"
            *ngIf="stepper.selectedIndex === 3"
        ></app-token-validate>
    </nb-step>
</nb-stepper>
